import { useCallback, useEffect, useState } from "react";

import "../commonComponents/CSS/styles.css";

import axios from "axios";
import JobDisplay from "./InboxComponents/JobDisplay";

import Messenger from "./InboxComponents/Messenger";
import { Layout, Modal } from "antd";

import "./Inbox.css";
import ChatList from "./InboxComponents/ChatList";

import { useMediaQuery } from "@mui/material";
import { useChatContext } from "../../Context/ChatContext";
import { useJRContext } from "../../Context/JobRequestContext";
import Agreement from "../commonComponents/Agreement";
import { useParams } from "react-router";

const { Sider, Content } = Layout;
const InboxPage = () => {
  const params = useParams();

  const { socket, onlineUsers, sendNewMessage, updateChatToRead } =
    useChatContext();

  const [chatting, setChatting] = useState(false);
  const [jobView, setJobView] = useState(false);

  const [chatID, setChatID] = useState(null);
  // id of currently open job
  const [openJob, setOpenJob] = useState(null);
  const { openJR, setOpenJR } = useJRContext();
  const [agreementOpen, setAgreementOpen] = useState(false);

  const {
    jobRequests,
    JRsLoading,
    chatList,
    chatListloading,
    messages,
    setMessages,
    conversation,
    jrConversation,
    conversationLoading,
    getConversation,
    reloadMessages,
    reloadChatList,
    reloadJRs,
    appendMessage,
  } = useConversationLoader(chatID, openJob);

  useEffect(() => {
    // console.log(params);
    let jobId = null;
    let chatId = null;
    if (typeof params.jobId === "string") {
      const id = Number.parseInt(params.jobId);
      jobId = !isNaN(id) ? id : null;
    }
    if (typeof params.id === "string") {
      const id = Number.parseInt(params.id);
      chatId = !isNaN(id) ? id : null;
    }

    setChatID(chatId);
    setOpenJob(jobId);
    if (openJR != null && openJR.job_id !== jobId) {
      setOpenJR(null);
    }

    if (jobId != null && chatId != null) {
      getConversation(chatId, jobId);
    }
  }, [params]);

  useEffect(() => {
    reloadChatList();
  }, []);

  // receive message
  useEffect(() => {
    if (socket === null) return;

    socket.on("getMessage", (res) => {
      console.log(res, "uouououououououo");

      if (
        openJR !== null &&
        parseInt(chatID) === parseInt(res.conversation_id) &&
        openJR.jr_conversation_id === res.jr_conversation_id
      ) {
        console.log(true);

        updateChatToRead(chatID, openJR.job_id, res.jr_conversation_id);
        reloadMessages();
      }

      reloadChatList();
      reloadJRs();
    });
    return () => {
      socket.off("getMessage");
      // socket.off("getNotification");
    };
  }, [socket, chatList, messages]);

  const mobileView = useMediaQuery("(max-width: 600px)");
  console.log(chatID);
  return (
    <>
      {!mobileView ? (
        <Layout className="commmunicationLayout communicationDesktop">
          <Sider width={300} id="commSiderLeft" style={{ overflow: "auto" }}>
            <ChatList
              socket={socket}
              setChatID={setChatID}
              chatList={chatList}
              getChatList={reloadChatList}
              chatId={chatID}
              onlineUsers={onlineUsers}
            />
          </Sider>
          {chatID !== null ? (
            <Content id="allJobRequests">
              <JobDisplay
                fetchJrData={reloadJRs}
                conversationID={chatID}
                getConversation={getConversation}
                setJobView={setJobView}
                jrList={jobRequests}
                chatId={chatID}
                openJob={openJob}
                setOpenJob={setOpenJob}
                setAgreementOpen={setAgreementOpen}
              />
            </Content>
          ) : null}
          <Content id="communicationContent">
            {chatID !== null && openJR !== null ? (
              <Messenger
                setJobView={setJobView}
                socket={socket}
                chatId={chatID}
                reloadChatList={reloadChatList}
                messages={messages}
                appendMessage={appendMessage}
                reloadMessages={reloadMessages}
                jrConversation={jrConversation}
                conversation={conversation}
                conversationLoading={conversationLoading}
              />
            ) : (
              <NoMessage />
            )}
          </Content>
        </Layout>
      ) : (
        <>
          {chatID !== null ? (
            !jobView ? (
              <JobDisplay
                fetchJrData={reloadJRs}
                conversationID={chatID}
                getConversation={getConversation}
                setJobView={setJobView}
                jrList={jobRequests}
                chatId={chatID}
                openJr={openJob}
                setOpenJob={setOpenJob}
                setAgreementOpen={setAgreementOpen}
              />
            ) : (
              <Messenger
                setJobView={setJobView}
                setChatting={setChatting}
                className="mr-2 m-auto"
                chatId={chatID}
                reloadChatList={reloadChatList}
                messages={messages}
                reloadMessages={reloadMessages}
                appendMessage={appendMessage}
                conversation={conversation}
                jrConversation={jrConversation}
                conversationLoading={conversationLoading}
              />
            )
          ) : (
            // !chatting && (
            <ChatList
              socket={socket}
              setChatID={setChatID}
              chatList={chatList}
              getChatList={reloadChatList}
              chatId={chatID}
              onlineUsers={onlineUsers}
              setChatting={setChatting}
            />
            // )
          )}
        </>
      )}
      {/* <Modal
        destroyOnClose={true}
        width="1000px"
        title="Service Agreement"
        open={agreementOpen}
        onCancel={() => setAgreementOpen(false)}
        footer={false}
      >
        {agreementOpen && (
          <Agreement
            hasAgreed={1}
            vendorLegalName={openJR.vendor_legal_name}
            clientName={openJR.clientName}
            workDescription={openJR.job_description}
            provinceName={openJR.province_name}
            jobId={openJR.job_id}
            closeAgreement={() => setAgreementOpen(false)}
          />
        )}
      </Modal> */}
    </>
  );
};
/* Displays when no thread is specified in the main body. Only used in desktop view */
const NoMessage = () => {
  return (
    <div className="noSelectedImg text-center">
      <img
        src={require("../../images/emptyThread.png")}
        alt={"noMessageSelected"}
      />
      <div className="g-text-lg">
        Select a thread to the left to open the messenger.
      </div>
    </div>
  );
};

function useConversationLoader(chatID = null, open_job = null) {
  const [jobRequests, setJobRequests] = useState([]);
  const [JRsLoading, setJRsLoading] = useState(true);
  const [chatList, setChatList] = useState([]);
  const [chatListloading, setChatListLoading] = useState(true);
  const [messages, setMessages] = useState([]);
  const [conversation, setConversation] = useState(null);
  const [jrConversation, setJrConversation] = useState(null);
  const [conversationLoading, setConversationLoading] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);

  const { updateChatToRead } = useChatContext();
  const { openJR, setOpenJR } = useJRContext();

  const reloadChatList = useCallback(() => {
    setChatListLoading(true);
    axios.get("/communication/getChatList").then((response) => {
      console.log(response.data.chatList);
      setChatList(response.data.chatList);
      setChatListLoading(false);
    });
  }, [setChatList]);

  const getConversation = useCallback(
    (conversationID, jobID) => {
      if (conversationID == null || jobID == null) {
        return;
      }
      setMessages([]);
      setConversationLoading(true);

      axios
        .post(`/communication/conversation/${conversationID}`, { jobId: jobID })
        .then((results) => {
          console.log(results.data);
          const jrConversationId =
            results.data.jrConversation.jr_conversation_id;
          if (results.data.jrConversation.unread !== 0) {
            updateChatToRead(conversationID, jobID, jrConversationId).then(
              () => {
                reloadJRs();
              }
            );
          }
          reloadChatList();
          setMessages(results.data.messages);
          setConversation(results.data.conversation);
          setJrConversation(results.data.jrConversation);
          console.log("jrConversation", results.data.jrConversation);
          if (
            firstLoad ||
            (openJR !== null &&
              results.data.jrConversation.job_id !== openJR.job_id)
          ) {
            setOpenJR(results.data.jrConversation);
            setFirstLoad(false);
          }
        })
        .finally(() => {
          setConversationLoading(false);
        });
    },
    [openJR, setOpenJR, reloadChatList, setMessages, setConversation]
  );

  const reloadJRs = useCallback(() => {
    if (chatID != null) {
      setJRsLoading(true);
      axios
        .post("/communication/getConversationJR", {
          ConversationId: Number.parseInt(chatID),
        })
        .then((response) => {
          // console.log(response.data.jrList);
          setJobRequests(response.data.jrList);
          setJRsLoading(false);
        });
    }
  }, [chatID, setJobRequests]);

  const reloadMessages = useCallback(() => {
    if (openJR == null) {
      console.error("Can't load messages openJR==null");
      return;
    }
    axios
      .post(`/communication/conversation/${chatID}`, { jobId: openJR.job_id })
      .then((results) => {
        const jrConversationId = results.data.jrConversation.jr_conversation_id;
        updateChatToRead(chatID, openJR.job_id, jrConversationId);
        reloadChatList();
        setMessages(results.data.messages);
        setConversation(results.data.conversation);
        const jrConversation = results.data.jrConversation;
        jrConversation.unread = 0;
        setJrConversation(jrConversation);
        setOpenJR(jrConversation);
      });
  });

  useEffect(() => {
    if (chatID !== null) reloadJRs();
    else {
      setJobRequests([]);
    }
  }, [reloadJRs, chatID, setJobRequests]);

  /*
  useEffect(()=>{
    if (openJR !== null && chatID !== null){
      setMessages([])
      getConversation(chatID, openJR.job_id);
    }

  },[chatID, openJR, getConversation])
  */

  const appendMessage = (message) => {
    setMessages((mgs) => [...mgs, message]);
  };

  return {
    jobRequests,
    JRsLoading,
    chatList,
    chatListloading,
    messages,
    setMessages,
    conversation,
    jrConversation,
    conversationLoading,
    getConversation,
    reloadMessages,
    reloadChatList,
    reloadJRs,
    appendMessage,
  };
}

export default InboxPage;
